module.exports = __webpack_public_path__ + "static/media/FEMALE.c1669035.png";